/* =======================================================================
   Departments.js — COMPLETE FILE (with collapsing hamburger & intro cards)
   ======================================================================= */
   import React, { useState, useEffect, useRef } from 'react';
   import { useParams, Link } from 'react-router-dom';
   import axios from 'axios';
   
   import 'owl.carousel/dist/assets/owl.carousel.css';
   import 'owl.carousel/dist/assets/owl.theme.default.css';
   import 'owl.carousel/dist/owl.carousel';
   
   import $ from 'jquery';
   import './Departments.css';
   
   window.jQuery = $;
   window.$      = $;
   
   /* ────────────────────────────────────────────────────────────────────
      helpers
   ──────────────────────────────────────────────────────────────────── */
   const TRIM   = 200;
   const clamp  = (txt = '', n = TRIM) =>
     txt.length > n ? `${txt.slice(0, n)}…` : txt;
   
   const domainRx = /^https?:\/\/121\.52\.154\.120:3001\//i;
   const urlRx    = /(https?:\/\/[^\s]+)/g;
   
   const cleanDescr = (txt = '', dl = false) => {
     if (!txt) return 'No Description Available';
     const urls  = txt.match(urlRx) || [];
     const body  = txt.replace(urlRx, '').trim();
     const short = clamp(body);
     if (!urls.length) return short;
   
     if (dl) {
       const links = urls
         .map((u) =>
           domainRx.test(u)
             ? `<a href="${u}" target="_blank" rel="noopener noreferrer">Download</a>`
             : `<a href="${u}" target="_blank" rel="noopener noreferrer">See&nbsp;more&nbsp;details</a>`
         )
         .join(' ');
       return `${short}<br/>${links}`;
     }
     return `${short} <a href="${urls[0]}" target="_blank" rel="noopener noreferrer">See&nbsp;more&nbsp;details</a>`;
   };
   
   const useFetch = (url, fallback) => {
     const [data, set] = useState(fallback);
     useEffect(() => {
       let live = true;
       const token = localStorage.getItem('authToken');
       axios
         .get(url, { headers: { Authorization: `Bearer ${token}` } })
         .then(({ data }) => live && set(data ?? fallback))
         .catch(()    => live && set(fallback));
       return () => { live = false; };
     }, [url]);
     return data;
   };
   
   const slideHTML = (arr, isDownload) =>
     arr
       .map(
         (x) => `
         <div class="common-card">
           <img class="common-card-image"
                src="http://121.52.154.120:3001${x.imageUrl}"
                alt="${x.title || ''}" />
           <div class="card-content">
             <h5 class="card-title">${x.title || ''}</h5>
             <p class="card-description two-lines">${cleanDescr(x.description || '', isDownload)}</p>
           </div>
         </div>`
       )
       .join('');
   
   const owlOpts = {
     items: 2,
     margin: 10,
     loop: true,
     nav: true,
     navText: [
       '<i class="fas fa-chevron-left"></i>',
       '<i class="fas fa-chevron-right"></i>',
     ],
     autoplay: true,
     autoplayTimeout: 5000,
     autoplayHoverPause: true,
   };
   
   const ViewAllLink = ({ to, onClick }) => (
     <div className="view-all-container">
       <Link className="view-all-link" to={to} onClick={onClick}>
         View&nbsp;All
       </Link>
     </div>
   );
   
   export default function Departments() {
     /* ── HIDE GLOBAL NAVBAR ───────────────────────────────────────────*/
     useEffect(() => {
       const topNav = document.getElementById('top-navbar');
       if (topNav) topNav.style.display = 'none';
       return () => {
         if (topNav) topNav.style.display = '';
       };
     }, []);
   
     /* ── Mobile‐menu state ─────────────────────────────────────────────*/
     const [isNavOpen, setIsNavOpen] = useState(false);
     const closeNav = () => setIsNavOpen(false);
     const toggleNav = () => setIsNavOpen(o => !o);
   
     const { id: deptId } = useParams();
   
     /* ── data pulls ───────────────────────────────────────────────*/
     const dept     = useFetch(`http://121.52.154.120:3001/api/departments/public/${deptId}`, null);
     const sliders  = useFetch(`http://121.52.154.120:3001/api/dept-sliders/${deptId}`, []).slice().reverse();
   
     const introRaw  = useFetch(`http://121.52.154.120:3001/api/dept-details/introduction/${deptId}`, { introduction: '' }).introduction;
     const chMsg     = useFetch(`http://121.52.154.120:3001/api/dept-details/chairman-message/${deptId}`, { chairmanMessage: '' }).chairmanMessage;
     const vision    = useFetch(`http://121.52.154.120:3001/api/dept-details/vision/${deptId}`,  { vision: '' }).vision;
     const mission   = useFetch(`http://121.52.154.120:3001/api/dept-details/mission/${deptId}`, { missionStatement: '' }).missionStatement;
     const peosRaw   = useFetch(`http://121.52.154.120:3001/api/dept-details/peos/${deptId}`,    { PEOs: '' }).PEOs;
   
     const research  = useFetch(`http://121.52.154.120:3001/api/dept-research/${deptId}`,        []).slice().reverse();
     const news      = useFetch(`http://121.52.154.120:3001/api/dept-news-events/${deptId}`,     []).slice().reverse();
     const circulars = useFetch(`http://121.52.154.120:3001/api/dept-circulars-info/${deptId}`,  []).slice().reverse();
   
     /* chairman photo */
     const [chairImg, setChair] = useState('http://121.52.154.120:3001/images/default-chairman.jpg');
     useEffect(() => {
       if (!dept?.deptname) return;
       axios.get('http://121.52.154.120:3001/api/faculty-directory').then(({ data = [] }) => {
         const c = data.find(
           (m) =>
             m.department === dept.deptname &&
             /(chairman)/i.test(`${m.designation || ''} ${m.currentPortfolio || ''}`)
         );
         if (c?.fimages) setChair(c.fimages);
       });
     }, [dept]);
   
     /* hero-slider automatic advance */
     const [cur, setCur] = useState(0);
     useEffect(() => {
       if (!sliders.length) return;
       const t = setTimeout(
         () => setCur((p) => (p + 1) % sliders.length),
         cur === 0 ? 30000 : 7000
       );
       return () => clearTimeout(t);
     }, [cur, sliders.length]);
   
     /* Owl refs */
     const refResearch  = useRef(null);
     const refNews      = useRef(null);
     const refCirculars = useRef(null);
   
     /* init / refresh Owl */
     const initOwl = (ref, arr, isDownload) => {
       const $el = $(ref.current);
       if (!$el.length || !arr.length) return;
       if (!$el.hasClass('owl-loaded')) {
         $el.html(slideHTML(arr, isDownload)).owlCarousel(owlOpts);
       } else {
         $el.trigger('replace.owl.carousel', [slideHTML(arr, isDownload)])
            .trigger('refresh.owl.carousel');
       }
     };
     useEffect(() => initOwl(refResearch,  research,  true),  [research]);
     useEffect(() => initOwl(refNews,      news,      false), [news]);
     useEffect(() => initOwl(refCirculars, circulars, true),  [circulars]);
   
     const SideCard = (item) =>
       item ? (
         <div className="common-card">
           <img
             className="common-card-image"
             src={`http://121.52.154.120:3001${item.imageUrl}`}
             alt={item.title}
           />
           <div className="card-content">
             <h5 className="card-title">{item.title}</h5>
             <p className="card-description two-lines">{cleanDescr(item.description, true)}</p>
           </div>
         </div>
       ) : null;
   
     /* ── RENDER ───────────────────────────────────────────────────*/
     return (
       <>
         {/* HERO SLIDER */}
         <div className="carousel">
           <div className="list">
             {sliders.map((s, i) => (
               <div key={s.id} className={`item ${i === cur ? 'active' : ''}`}>
                 <img src={`http://121.52.154.120:3001${s.imageUrl}`} alt={s.caption} />
                 <div className="content">
                   <p>{dept?.deptname || 'Department'}</p>
                   <div className="title">{s.caption}</div>
                   <div className="description">{clamp(s.detail, 300)}</div>
                 </div>
               </div>
             ))}
           </div>
           {sliders.length > 1 && (
             <div className="arrows">
               <button id="prev" onClick={() => setCur((p) => (p - 1 + sliders.length) % sliders.length)} />
               <button id="next" onClick={() => setCur((p) => (p + 1) % sliders.length)} />
             </div>
           )}
         </div>
   
         {/* DEPARTMENT‐NAVBAR */}
         <nav className="horizontal-navbar">
           <div className="hamburger" onClick={toggleNav} aria-label="Toggle menu">
             <i className="fas fa-bars" />
           </div>
           <ul className={`horizontal-navbar-menu${isNavOpen ? ' open' : ''}`}>
             <li><a href="#introduction" onClick={closeNav}>Introduction</a></li>
             <li><a href="#chairman-message" onClick={closeNav}>Chairman Message</a></li>
             <li><a href="#vision" onClick={closeNav}>Vision</a></li>
             <li><a href="#mission" onClick={closeNav}>Mission</a></li>
             <li>
               <Link to={`/department/${deptId}/faculty`} onClick={closeNav}>
                 Faculty
               </Link>
             </li>
             <li><a href="#research" onClick={closeNav}>Research</a></li>
             <li><a href="#news-events" onClick={closeNav}>News</a></li>
             <li><a href="#circulars" onClick={closeNav}>Circulars</a></li>
           </ul>
         </nav>
   
         {/* MAIN CONTENT */}
         <div className="page-container container">
           <h2 className="consultative-events-heading">{dept?.deptname}</h2>
   
           {/* Introduction with last four lines as cards */}
           <section id="introduction" className="upload-section">
             <h3>Introduction</h3>
             {introRaw ? (() => {
               const lines = introRaw.split('\n').map(l => l.trim()).filter(Boolean);
               const main = lines.slice(0, lines.length - 4).join('\n');
               const extras = lines.slice(-4);
               return (
                 <>
                   {main && <p>{main}</p>}
                   {extras.length > 0 && (
                     <div className="intro-cards-container">
                       {extras.map((line, i) => (
                         <div
                           key={i}
                           className="intro-card"
                           style={{
                             backgroundColor: ['#e74c3c','#3498db','#2ecc71','#f1c40f'][i % 4]
                           }}
                         >
                           {line}
                         </div>
                       ))}
                     </div>
                   )}
                 </>
               );
             })() : <p>No introduction available.</p>}
           </section>
   
           {/* Chairman Message */}
           <section id="chairman-message" className="upload-section">
             <h3>Chairman Message</h3>
             <img src={chairImg} alt="Chairman" className="chairman-image" />
             <p>{chMsg || 'No chairman message available.'}</p>
           </section>
   
           {/* Vision & Mission */}
           <section id="vision" className="upload-section">
             <h3>Vision</h3>
             <p>{vision || 'No vision available.'}</p>
           </section>
           <section id="mission" className="upload-section">
             <h3>Mission</h3>
             <p>{mission || 'No mission statement available.'}</p>
           </section>
   
           {/* PEOs as coloured cards */}
           <section id="peos" className="upload-section">
             <h3>Program Educational Objectives (PEOs)</h3>
             {peosRaw
               ? peosRaw.split('\n').filter(s => s.trim()).map((obj, i) => (
                   <div
                     key={i}
                     className="peo-card"
                     style={{
                       backgroundColor: ['#e74c3c','#3498db','#2ecc71','#f1c40f','#9b59b6'][i % 5]
                     }}
                   >
                     {obj.trim()}
                   </div>
                 ))
               : <p>No PEOs available.</p>}
           </section>
   
           {/* Research */}
           <section id="research" className="upload-section">
             <h3>Research</h3>
             <div className="row">
               <div className="col-md-7">{SideCard(research[0])}</div>
               <div className="col-md-5"><div ref={refResearch} className="owl-carousel research-slider" /></div>
             </div>
             <ViewAllLink to={`/department/${deptId}/all/research`} onClick={closeNav} />
           </section>
   
           {/* News & Events */}
           <section id="news-events" className="upload-section">
             <h3>News & Events</h3>
             <div className="row">
               <div className="col-md-7">{SideCard(news[0])}</div>
               <div className="col-md-5"><div ref={refNews} className="owl-carousel news-slider" /></div>
             </div>
             <ViewAllLink to={`/department/${deptId}/all/news`} onClick={closeNav} />
           </section>
   
           {/* Circulars */}
           <section id="circulars" className="upload-section">
             <h3>Circulars & Information</h3>
             <div className="row">
               <div className="col-md-7">{SideCard(circulars[0])}</div>
               <div className="col-md-5"><div ref={refCirculars} className="owl-carousel circulars-slider" /></div>
             </div>
             <ViewAllLink to={`/department/${deptId}/all/circulars`} onClick={closeNav} />
           </section>
         </div>
       </>
     );
   }
   